/* Slide-out shop drawer (regionalized logo, Top Sellers, curated taxonomy, category overrides).
   Externalized from swish-shop-drawer.liquid so the menu logic can be re-published
   without a theme paste. Loaded via <script src="{{ 'swish-shop-drawer.js' | file_url }}" defer>.
   Re-publish through the staged-upload + fileUpdate path. */

(function() {
  'use strict';
  var CONFIG_URL = window.menuConfigUrl || 'https://cdn.shopify.com/s/files/1/0028/1852/files/product-menu-config.json';
  var ICON_BASE = 'https://cdn.shopify.com/s/files/1/0028/1852/files/';
  /* Daily Dozen feature block — sits between Top Sellers and Other Categories. */
  var DD_HREF = '/collections/daily-dozen';
  var DD_ICON = 'https://cdn.shopify.com/s/files/1/0028/1852/files/dd-sale-tag.svg';
  var DD_TITLE = 'Daily Dozen';
  var DD_SUB = '12 archive designs · new every day · today only';
  /* Pride feature block — SEASONAL, sits just above Daily Dozen, rainbow-animated.
     Auto-disappears on July 1, 2026. */
  var PRIDE_HREF = '/pages/shop-for-pride';
  var PRIDE_TITLE = 'Shop for Pride';
  var PRIDE_SUB = 'The whole Pride edit · all month long';
  function isPrideActive() { return new Date() < new Date(2026, 6, 1); } /* before Jul 1, 2026 */
  function injectPrideDrawerStyle() {
    if (document.getElementById('tp-drawer-pride-style')) return;
    var st = document.createElement('style');
    st.id = 'tp-drawer-pride-style';
    st.textContent =
      '@keyframes tpDrawerPrideFlow{to{background-position:200% 0;}}' +
      '.tp-drawer__pride-block{position:relative;border-color:transparent !important;}' +
      '.tp-drawer__pride-block::before{content:"";position:absolute;inset:0;border-radius:inherit;padding:1.6px;background:linear-gradient(90deg,#E40303,#FF8C00,#FFED00,#008026,#004DFF,#750787,#E40303);background-size:200% 100%;-webkit-mask:linear-gradient(#000 0 0) content-box,linear-gradient(#000 0 0);-webkit-mask-composite:xor;mask-composite:exclude;animation:tpDrawerPrideFlow 4s linear infinite;pointer-events:none;}' +
      '.tp-drawer__pride-title{background:linear-gradient(90deg,#E40303,#FF8C00,#FFED00,#008026,#004DFF,#750787);background-size:200% 100%;-webkit-background-clip:text;background-clip:text;color:transparent !important;animation:tpDrawerPrideFlow 6s linear infinite;}' +
      '@media(prefers-reduced-motion:reduce){.tp-drawer__pride-block::before,.tp-drawer__pride-title{animation:none !important;}}';
    document.head.appendChild(st);
  }
  var drawer = document.getElementById('tp-drawer');
  var overlay = document.getElementById('tp-drawer-overlay');
  var closeBtn = document.getElementById('tp-drawer-close');
  var body = document.getElementById('tp-drawer-body');
  var logoImg = document.getElementById('tp-drawer-logo-img');
  var logoLink = document.getElementById('tp-drawer-logo');
  /* Move overlay + drawer to document.body so they escape any
     Shopify section wrapper stacking context */
  document.body.appendChild(overlay);
  document.body.appendChild(drawer);
  /* --- LOGO: clone the footer logo's src so the drawer header tracks
     whatever localized variant the storefront is showing (e.g.
     Swish-Canada-White.svg on .ca, Swish-Embassy-White.svg on .com).
     If we can't find a footer image, leave the text fallback ("Swish
     Embassy" in the img's alt) by hiding the img element. */
  function syncDrawerLogo() {
    if (!logoImg) return;
    var src = null;
    var alt = 'Swish Embassy';
    var candidates = [
      'footer img.footer-block__image',
      '.footer img.footer-block__image',
      '[class*=footer] img.footer-block__image',
      'footer img[src*="Swish"]',
      'footer img'
    ];
    for (var i = 0; i < candidates.length; i++) {
      var el = document.querySelector(candidates[i]);
      if (el && el.src) {
        src = el.src;
        if (el.alt) alt = el.alt;
        break;
      }
    }
    if (src) {
      logoImg.src = src;
      logoImg.alt = alt;
      logoImg.style.display = '';
    } else {
      // No footer image found — fall back to plain text inside the link.
      logoImg.style.display = 'none';
      if (logoLink && !logoLink.querySelector('.tp-drawer__logo-text')) {
        var span = document.createElement('span');
        span.className = 'tp-drawer__logo-text';
        span.textContent = 'Swish Embassy';
        logoLink.appendChild(span);
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncDrawerLogo, { once: true });
  } else {
    syncDrawerLogo();
  }
  /* --- OPEN / CLOSE (iOS-safe scroll lock) --- */
  var savedScrollY = 0;
  function openDrawer() {
    // Re-sync on every open — covers any case where Shopify Markets swaps the
    // footer logo after our initial sync (e.g. currency change on the same page).
    syncDrawerLogo();
    savedScrollY = window.scrollY;
    document.documentElement.classList.add('tp-drawer-locked');
    document.body.style.top = '-' + savedScrollY + 'px';
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.documentElement.classList.remove('tp-drawer-locked');
    document.body.style.top = '';
    window.scrollTo(0, savedScrollY);
  }
  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeDrawer();
  });
  /* --- EXPOSE GLOBAL API --- */
  window.tpDrawer = { open: openDrawer, close: closeDrawer };
  /* --- DELEGATED TRIGGER (survives AJAX page swaps) --- */
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-tp-drawer-trigger]');
    if (trigger) {
      e.preventDefault();
      openDrawer();
    }
  });
  /* --- CATEGORY GROUPING --- */
  var CATEGORY_META = {
    'Signature Apparel': { sub: 'Core collection tees, crops, and more', order: 1 },
    'Summer & Resort Wear': { sub: 'Swim, kaftans, button shirts, and more', order: 2 },
    'Premium Outerwear & Knits': { sub: 'Hoodies, jackets, sweats, and more', order: 3 },
    'Headwear & Accessories': { sub: 'Hats, pet gear, and more', order: 4 },
    'Lifestyle & Home Decor': { sub: 'Mugs, bags, candles, and more', order: 5 },
    'Seasonal & Specialty': { sub: 'Holiday ornaments, cards, and more', order: 6 }
  };
  /* Curated "Top Sellers" tile list — keys match v.key in the menu config.
     Missing keys (or any key whose href === currentPath) are filtered out
     at render time. Order in this array is the order shown in the grid. */
  var TOP_SELLERS_KEYS = [
    't-shirt',
    'tank-top',
    'polo',
    'triblend-t-shirt',
    'kaftan',
    'mug',
    'raglan',
    'swim-briefs',
    'coaster',
    'leather'
  ];
  var TOP_SELLERS_META = { sub: 'Our most-loved categories' };
  /* Keys we want hidden from the drawer entirely. Doesn't affect any
     other surface that reads the same config — only this drawer's
     category sections. Add more keys here to hide more items. */
  var HIDDEN_FROM_DRAWER = { 'pet-shirt': 1, 'pet-hoodie': 1 };
  /* Override the config-assigned category for specific keys. Drawer-only
     — doesn't touch the source config or any other surface. */
  var CATEGORY_OVERRIDES = { 'leather': 'Headwear & Accessories' };
  /* These categories are wrapped inside a single collapsible "Other
     Categories" parent. Anything not in this set stays at the top level
     alongside Top Sellers. */
  var NESTED_UNDER_OTHER = {
    'Signature Apparel': 1,
    'Summer & Resort Wear': 1,
    'Premium Outerwear & Knits': 1,
    'Headwear & Accessories': 1,
    'Lifestyle & Home Decor': 1
  };
  var OTHER_META = { sub: 'Browse the full catalog by category' };
  /* --- RENDER DRAWER CONTENT --- */
  function renderDrawer(cfg) {
    if (!cfg || !cfg.variants) return;
    var currentPath = window.location.pathname;
    if (currentPath.length > 1 && currentPath.endsWith('/')) {
      currentPath = currentPath.slice(0, -1);
    }
    /* Group visible variants by category AND build a key->variant lookup so
       the curated Top Sellers list below can resolve labels/hrefs/icons. */
    var groups = {};
    var variantByKey = {};
    cfg.variants.forEach(function(v) {
      variantByKey[v.key] = v;
      if (v.hidden_on_menu) return;
      if (HIDDEN_FROM_DRAWER[v.key]) return;
      var cat = CATEGORY_OVERRIDES[v.key] || v.category || 'Other';
      if (!groups[cat]) groups[cat] = [];
      var iconKey = v.icon;
      var iconFile = (cfg.icons && cfg.icons[iconKey]) || 'star.svg';
      var iconUrl = iconFile.indexOf('http') === 0 ? iconFile : ICON_BASE + iconFile;
      groups[cat].push({
        label: v.label,
        href: v.href || '/collections/all',
        icon: iconUrl,
        priority: v.priority || 99
      });
    });
    /* Resolve the curated Top Sellers keys against the config. Skip any
       key that isn't in the config, is hidden, or links to the current page. */
    var topSellersItems = TOP_SELLERS_KEYS.map(function(key) {
      var v = variantByKey[key];
      if (!v || v.hidden_on_menu) return null;
      var href = v.href || '/collections/all';
      if (href === currentPath) return null;
      var iconKey = v.icon;
      var iconFile = (cfg.icons && cfg.icons[iconKey]) || 'star.svg';
      var iconUrl = iconFile.indexOf('http') === 0 ? iconFile : ICON_BASE + iconFile;
      return { label: v.label, href: href, icon: iconUrl };
    }).filter(function(x) { return x; });
    /* Sort items within each group by priority */
    Object.keys(groups).forEach(function(cat) {
      groups[cat].sort(function(a, b) { return a.priority - b.priority; });
    });
    /* Sort categories by defined order */
    var sortedCats = Object.keys(groups).sort(function(a, b) {
      var oa = (CATEGORY_META[a] && CATEGORY_META[a].order) || 99;
      var ob = (CATEGORY_META[b] && CATEGORY_META[b].order) || 99;
      return oa - ob;
    });
    var html = '';
    /* --- TOP SELLERS — curated section, sits above the config-driven
       categories and is the only one expanded by default. */
    if (topSellersItems.length > 0) {
      html += '<div class="tp-drawer__section is-expanded" data-tp-section="top-sellers">';
      html += '<div class="tp-drawer__section-header">';
      html += '<div><div class="tp-drawer__section-title">Top Sellers</div>';
      html += '<div class="tp-drawer__section-sub">' + TOP_SELLERS_META.sub + '</div></div>';
      html += '<div class="tp-drawer__section-arrow">&rsaquo;</div>';
      html += '</div>';
      html += '<div class="tp-drawer__products"><div class="tp-drawer__pgrid">';
      topSellersItems.forEach(function(item) {
        html += '<a href="' + item.href + '" class="tp-drawer__ptile">';
        html += '<div class="tp-drawer__ptile-icon"><img src="' + item.icon + '" alt="' + item.label + '" loading="lazy" onerror="this.style.display=\'none\'"></div>';
        html += '<div class="tp-drawer__ptile-label">' + item.label + '</div>';
        html += '</a>';
      });
      html += '</div></div></div>';
    }
    /* --- SHOP FOR PRIDE — seasonal feature block, sits just above Daily Dozen. --- */
    if (isPrideActive() && currentPath !== PRIDE_HREF.replace(/\/$/, '')) {
      injectPrideDrawerStyle();
      html += '<a href="' + PRIDE_HREF + '" class="tp-drawer__pride-block" style="display:flex;align-items:center;gap:14px;margin:14px 0;padding:16px 18px;background:#0c0c0e;border:1.5px solid transparent;border-radius:16px;text-decoration:none;">';
      html += '<div style="flex:0 0 46px;width:46px;height:46px;border-radius:12px;background:rgba(255,255,255,0.06);display:flex;align-items:center;justify-content:center;font-size:26px;line-height:1;">🏳️‍🌈</div>';
      html += '<div style="flex:1 1 auto;min-width:0;">';
      html += '<div class="tp-drawer__pride-title" style="font-weight:800;font-size:16px;letter-spacing:-0.01em;line-height:1.2;">' + PRIDE_TITLE + '</div>';
      html += '<div style="font-size:12.5px;color:#cfcfd4;margin-top:3px;line-height:1.35;">' + PRIDE_SUB + '</div>';
      html += '</div>';
      html += '<div style="flex:0 0 auto;color:#fff;font-size:24px;font-weight:700;line-height:1;opacity:.7;">&rsaquo;</div>';
      html += '</a>';
    }
    /* --- DAILY DOZEN — big feature block between Top Sellers and the categories. */
    if (currentPath !== DD_HREF) {
      html += '<a href="' + DD_HREF + '" class="tp-drawer__dd-block" style="display:flex;align-items:center;gap:14px;margin:14px 0;padding:16px 18px;background:#0c0c0e;border:1.5px solid #E8345E;border-radius:16px;text-decoration:none;">';
      html += '<div style="flex:0 0 46px;width:46px;height:46px;border-radius:12px;background:rgba(255,73,73,0.16);display:flex;align-items:center;justify-content:center;">';
      html += '<img src="' + DD_ICON + '" alt="" loading="lazy" style="width:27px;height:27px;" onerror="this.style.display=\'none\'">';
      html += '</div>';
      html += '<div style="flex:1 1 auto;min-width:0;">';
      html += '<div style="font-weight:800;font-size:16px;color:#fff;letter-spacing:-0.01em;line-height:1.2;">' + DD_TITLE + '</div>';
      html += '<div style="font-size:12.5px;color:#cfcfd4;margin-top:3px;line-height:1.35;">' + DD_SUB + '</div>';
      html += '</div>';
      html += '<div style="flex:0 0 auto;color:#E8345E;font-size:24px;font-weight:700;line-height:1;">&rsaquo;</div>';
      html += '</a>';
    }
    /* --- CATEGORY SECTIONS — partition into "nested under Other Categories"
       vs "top-level". Both buckets stay collapsed by default; only Top
       Sellers (above) auto-expands. */
    function renderSection(cat, ci) {
      var meta = CATEGORY_META[cat] || { sub: '', order: 99 };
      var items = groups[cat];
      var s = '';
      s += '<div class="tp-drawer__section" data-tp-section="' + ci + '">';
      s += '<div class="tp-drawer__section-header">';
      s += '<div><div class="tp-drawer__section-title">' + cat + '</div>';
      s += '<div class="tp-drawer__section-sub">' + meta.sub + '</div></div>';
      s += '<div class="tp-drawer__section-arrow">&rsaquo;</div>';
      s += '</div>';
      s += '<div class="tp-drawer__products"><div class="tp-drawer__pgrid">';
      items.forEach(function(item) {
        s += '<a href="' + item.href + '" class="tp-drawer__ptile">';
        s += '<div class="tp-drawer__ptile-icon"><img src="' + item.icon + '" alt="' + item.label + '" loading="lazy" onerror="this.style.display=\'none\'"></div>';
        s += '<div class="tp-drawer__ptile-label">' + item.label + '</div>';
        s += '</a>';
      });
      s += '</div></div></div>';
      return s;
    }
    var nestedCats = sortedCats.filter(function(c) { return NESTED_UNDER_OTHER[c]; });
    var topLevelCats = sortedCats.filter(function(c) { return !NESTED_UNDER_OTHER[c]; });
    /* Build the "Other Categories" wrapper if any of its members exist */
    if (nestedCats.length > 0) {
      html += '<div class="tp-drawer__section" data-tp-section="other-categories">';
      html += '<div class="tp-drawer__section-header">';
      html += '<div><div class="tp-drawer__section-title">Other Categories</div>';
      html += '<div class="tp-drawer__section-sub">' + OTHER_META.sub + '</div></div>';
      html += '<div class="tp-drawer__section-arrow">&rsaquo;</div>';
      html += '</div>';
      html += '<div class="tp-drawer__subsections">';
      nestedCats.forEach(function(cat, i) {
        html += renderSection(cat, 'other-' + i);
      });
      html += '</div></div>';
    }
    /* Render the categories that stay at the top level (e.g. Seasonal & Specialty) */
    topLevelCats.forEach(function(cat, ci) {
      html += renderSection(cat, ci);
    });
    /* --- BROWSE TOPICS (collections) --- */
    if (cfg.collections && cfg.collections.length > 0) {
      html += '<div class="tp-drawer__topics-title">Browse All Vibes</div>';
      html += '<div class="tp-drawer__topics">';
      cfg.collections.forEach(function(col) {
        if (col.href === currentPath) return;
        var pinClass = col.pinned ? ' is-pinned' : '';
        var iconUrl = '';
        if (col.icon) {
          iconUrl = col.icon.indexOf('http') === 0 ? col.icon : ICON_BASE + col.icon;
        }
        html += '<a href="' + col.href + '" class="tp-drawer__topic' + pinClass + '">';
        if (iconUrl) {
          html += '<img class="tp-drawer__topic-icon" src="' + iconUrl + '" alt="" loading="lazy" onerror="this.style.display=\'none\'">';
        }
        html += (col.text || col.key);
        html += '</a>';
      });
      html += '</div>';
    }
    /* --- ARTISTS & COLLABORATIONS --- */
    /* Every artist now has a page on the shared `artist` template, so these
       all point at /pages/<handle>. Do not point any of them back at a
       /collections/ URL — that skips the artist hero, the format tabs and
       the style counts. */
    var artists = [
      { name: 'Jason Bone',        href: '/pages/jason-bone' },
      { name: 'Mike Derry',        href: '/pages/derry-products' },
      { name: 'Glen Hanson',       href: '/pages/glen-hanson' },
      { name: 'Trent James',       href: '/pages/trent-james-draws' },
      { name: 'Maxxie LaWow',      href: '/pages/maxxie-lawow' },
      { name: 'Alejandro Mogollo', href: '/pages/alemogolloart' },
      { name: 'Tommy Joiner',      href: '/pages/tommy-joiner' },
      { name: 'Jock Mooney',       href: '/pages/jock-mooney' },
      { name: 'David Occhino',     href: '/pages/david-occhino-design' }
    ];
    html += '<div class="tp-drawer__topics-title">Artists & Collaborations</div>';
    html += '<div class="tp-drawer__topics">';
    artists.forEach(function(a) {
      if (a.href === currentPath) return;
      html += '<a href="' + a.href + '" class="tp-drawer__topic">' + a.name + '</a>';
    });
    html += '</div>';
    /* --- SUPPORT --- */
    html += '<div class="tp-drawer__support-title">Support</div>';
    html += '<div class="tp-drawer__support-links">';
    html += '<a href="/pages/order-status" class="tp-drawer__support-link"><svg viewBox="0 0 24 24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>Track Order</a>';
    html += '<a href="/pages/policies" class="tp-drawer__support-link"><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>FAQ</a>';
    html += '<a href="/pages/customer-service" class="tp-drawer__support-link"><svg viewBox="0 0 24 24"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>Contact Us</a>';
    html += '<a href="#" class="tp-drawer__support-link" data-tp-locale-trigger><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg>Region & Language</a>';
    html += '</div>';
    body.innerHTML = html;
    /* --- REGION/LANGUAGE: trigger Hextom's picker --- */
    var localeTrigger = body.querySelector('[data-tp-locale-trigger]');
    if (localeTrigger) {
      localeTrigger.addEventListener('click', function(e) {
        e.preventDefault();
        closeDrawer();
        setTimeout(function() {
          document.body.classList.add('ht-tms__popup__open');
        }, 350);
      });
    }
    /* --- ACCORDION BEHAVIOR ---
       "Close other sections" is scoped to SIBLINGS only. Without this scoping,
       expanding a nested section (e.g. Signature Apparel under Other Categories)
       would also collapse its parent (Other Categories), making the click
       feel broken. */
    body.querySelectorAll('.tp-drawer__section-header').forEach(function(header) {
      header.addEventListener('click', function(e) {
        e.stopPropagation();
        var section = header.parentElement;
        var wasExpanded = section.classList.contains('is-expanded');
        var siblingContainer = section.parentElement; // .tp-drawer__body OR .tp-drawer__subsections
        /* Close other sibling sections at this level */
        Array.prototype.forEach.call(siblingContainer.children, function(s) {
          if (s !== section && s.classList && s.classList.contains('tp-drawer__section')) {
            s.classList.remove('is-expanded');
          }
        });
        /* Toggle clicked section */
        if (!wasExpanded) {
          section.classList.add('is-expanded');
        } else {
          section.classList.remove('is-expanded');
        }
      });
    });
    /* Close drawer when clicking a link */
    body.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        setTimeout(closeDrawer, 100);
      });
    });
  }
  /* --- CLEAN UP stale state from bfcache or AJAX nav --- */
  closeDrawer();
  /* --- INIT: Fetch config and render --- */
  fetch(CONFIG_URL + '?v=' + Date.now())
    .then(function(r) { return r.json(); })
    .then(function(cfg) { renderDrawer(cfg); })
    .catch(function(e) {
      console.error('Drawer Error:', e);
      body.innerHTML = '<div style="padding:20px;color:#888;">Could not load menu.</div>';
    });
})();
